import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const accountSectionEntityName = 'accountSection';
export const accountSectionColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { title: {
        type: 'string-required',
    }, displayOrder: {
        type: 'number',
    }, description: {
        type: 'string',
    }, key: {
        type: 'string',
    }, showInPages: {
        type: 'string-array',
        index: true,
    }, validateCompletion: {
        type: 'string',
    }, validateLogin: {
        type: 'string',
    }, dataField: {
        type: 'string',
    }, visibility: {
        type: 'string',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
